<template>
  <div class="p-col-12">
    <page-header title="dataTable.budget-configuration.title" :actions="pageActions"/>
    <ancestryline-data-table :data-function="dataFunction" :columns="columns"/>
  </div>
</template>

<script>
import AncestrylineDataTable from "@/components/table/AncestrylineDataTable";
import FrontBusiness from "@/business/FrontBusiness";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import PageHeader from "@/components/page/PageHeader";
import Audit from "@/viewer/user/Audit";
import BudgetConfigurationBusiness from "@/business/BudgetConfigurationBusiness";
import DialogService from "@/business/ModalBusiness";
import AncestrylineConfirmation from "@/components/dialog/AncestrylineConfirmation";

export default {
  name: "BudgetConfigurationList",
  components: {PageHeader, AncestrylineDataTable},

  data() {
    return {
      dataFunction: BudgetConfigurationBusiness.pagination,
      columns: [
        {field: "name", header: 'dataTable.budget-configuration.columns.name', sortable:true},
        {field: "pageToEdit", header: 'dataTable.budget-configuration.columns.pageToEdit', sortable:true},
        {field: "startHorizontalPoint", header: 'dataTable.budget-configuration.columns.startHorizontalPoint', sortable:true},
        {field: "created", header: 'dataTable.budget-configuration.columns.created', sortable:true, type: 'date-time'},
        {field: "actions", header: 'dataTable.actions', sortable:false, type: 'actions', style: 'width: 100px',
          actions: [
            {icon: 'pi pi-pencil', title: 'dataTable.budget-configuration.columns.edit', function: this.editBudgetConfiguration},
            {icon: 'pi pi-trash', title: 'dataTable.budget-configuration.columns.delete', function: this.deleteBudgetConfiguration, refreshList: true},
          ]
        },
      ],
      pageActions: [
        {icon: 'pi pi-plus', label: 'dataTable.budget-configuration.add', url: '/budget-configuration'},
        {icon: 'pi pi-eye', label: 'audit.button-list', function: this.openModal, type: 'button'},
      ],
    }
  },

  methods: {

    editBudgetConfiguration(budgetConfiguration){
      FrontBusiness.redirect(`/budget-configuration/${budgetConfiguration.id}`);
    },

    async deleteBudgetConfiguration(budgetConfiguration, dataList){
      if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
        const response = await BudgetConfigurationBusiness.delete(budgetConfiguration.id).catch((e) => ToastMessageBusiness.showError(e.message));
        if(response){
          dataList = dataList.filter(c => c.id !== budgetConfiguration.id);
          ToastMessageBusiness.showSuccess();
        }
        return dataList;
      }
    },

    openModal(){
      DialogService.openModal(Audit, {business: BudgetConfigurationBusiness});
    },

  }

}
</script>

<style scoped>

</style>
